import { render, staticRenderFns } from "./PurchaseSendDialog.vue?vue&type=template&id=62dc583a&scoped=true&"
import script from "./PurchaseSendDialog.vue?vue&type=script&lang=js&"
export * from "./PurchaseSendDialog.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseSendDialog.vue?vue&type=style&index=0&id=62dc583a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dc583a",
  null
  
)

export default component.exports